const ComponentDecorator = (Class, observable = false, observe_class = true) => {
	return () => {
		let select = Class.select;
		if (select === undefined) {
			select = $context => $context.select(`.${Class.classname}`);
		}

		const C = Component(select, $component => new Class($component));

		if (observable) {
			ObserverUtil.observeComponent(Class.classname, C);

			if (observe_class) {
				ObserverUtil.observeClass(Class.classname, C);
			}
		}

		return C;
	};
};

const ObservableComponentDecorator = Class => {
	return ComponentDecorator(Class, true);
};

const NodeObservableComponentDecorator = Class => {
	return ComponentDecorator(Class, true, false);
};

export {
	ComponentDecorator as component, // Срабатывает только если элемент с соответствующим классом уже был в DOM
	ObservableComponentDecorator as observable_component, // Срабатывает всегда и при создании компонента и при добавлении любому элементу класса, соответствующего этому компоненту
	NodeObservableComponentDecorator as node_observable_component, // Срабатывает только при создании компонента, но не при модификациях классов
};
